<div
	[ngClass]="{
		'grid grid-cols-2 gap-2 items-center': labelPosition === 'left',
	}"
	class="relative"
>
	<p *ngIf="labelPosition === 'left'" class="flex-1">Premium</p>
	<div class="flex gap-2 items-center">
		<ng-container *ngIf="premiumPillData$ | async as premiumPillData">
			<div class="flex flex-1 gap-2 items-center">
				<app-input
					[label]="labelPosition === 'top' ? 'Premium' : ''"
					type="cents"
					[ngModel]="premium || 0"
					(debounce)="setPremium($event)"
					[testHook]="testHooks.Input"
				></app-input>
				<app-icon
					[class]="
						'w-5 cursor-pointer ' +
						premiumPillData.iconClass +
						(labelPosition === 'top' ? ' mt-5' : '')
					"
					[icon]="premiumPillData.icon"
					(click)="togglePill('premium')"
					[testHook]="testHooks.TogglePillIcon"
				></app-icon>
			</div>
			<div
				*ngIf="displayPill === 'premium'"
				class="gap-4 text-sm absolute -bottom-4 -right-24 bg-white border py-1 px-2 rounded-xl z-50 flex items-start justify-between"
			>
				<div>
					<app-icon
						[icon]="premiumPillData.icon"
						[class]="premiumPillData.iconClass"
					></app-icon>
					<span class="ml-3">{{ premiumPillData.text }}</span>
				</div>
				<app-icon
					class="cursor-pointer"
					[icon]="ICON.CLOSE"
					(click)="togglePill('none')"
					[testHook]="testHooks.TogglePillIcon1"
				></app-icon>
			</div>
		</ng-container>
	</div>
</div>
